/*----------------------------------
- VERIFY SIGNALS MOTION
- Two marquee rows naming the evidence one analysis returns. This replaced the
- abstract layered-card illustration: the tile's job is to say what Verify gives you,
- and nine named signals do that where a stylised card could only imply it.
----------------------------------*/

import Icon from '@/client/components/ui/icon/Icon';
import { HOME_ANALYSIS_SIGNALS } from '@/client/catalogs/landing/analysisSignals';

/*----------------------------------
- CONSTANTS
----------------------------------*/

// The marquee translates by -50%, so each row renders its signals twice and the loop
// closes seamlessly. Splitting 9 across two rows keeps both rows a similar width.
const ROWS: readonly (readonly string[])[] = [
    HOME_ANALYSIS_SIGNALS.slice(0, 5),
    HOME_ANALYSIS_SIGNALS.slice(5),
];

/*----------------------------------
- COMPONENT
----------------------------------*/

const VerifySignalsMotion = () => (
    <div class="ud-workflow-verify-signals" aria-hidden="true">
        {ROWS.map((row, rowIndex) => (
            <div
                key={rowIndex}
                class={`ud-workflow-verify-signals__rail${rowIndex === 1 ? ' ud-workflow-verify-signals__rail--reverse' : ''}`}
            >
                <div class="ud-workflow-verify-signals__track">
                    {[...row, ...row].map((signal, index) => (
                        <span key={`${signal}-${index}`} class="ud-workflow-verify-signals__chip">
                            <Icon name="check" size={13} />
                            <span>{signal}</span>
                        </span>
                    ))}
                </div>
            </div>
        ))}
    </div>
);

export default VerifySignalsMotion;
